import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer">
        Everything shown is real and authentic.
    </footer>
  )
}

export default Footer
